module.exports = __webpack_public_path__ + "img/lion.268c34fd.png";